import React, { useState } from 'react';
import { Check, Eye, EyeOff, MessageCircle } from 'lucide-react';
import VisorWeb from './VisorWeb';

/* Pantalla de una obra que todavía NO tiene el servicio (Recorrido 360° o Página web). Lo primero que se ve son dos
   botones: "Ver ejemplo" y "Contratar" con el precio. El ejemplo sólo se abre si lo tocan y avisa que es de otra obra,
   para que nadie crea que es su proyecto (pedido de Jairo 27/10). */
export default function SinServicio({ Icono, etiqueta, titulo, texto, precio, detallePrecio, contratarHref, contratarTexto, ejemploUrl, ejemploNombre, tipo, beneficios = [] }) {
  const [verEjemplo, setVerEjemplo] = useState(false);
  return (
    <div className="space-y-5">
      <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8">
        <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-700 bg-blue-50 px-2.5 py-1 rounded-full"><Icono size={13} />{etiqueta}</div>
        <h2 className="mt-3 text-2xl md:text-3xl font-bold text-gray-800 leading-tight">{titulo}</h2>
        <p className="text-gray-600 mt-2 max-w-3xl">{texto}</p>

        <div className="mt-6 grid md:grid-cols-2 gap-4">
          <button type="button" onClick={() => setVerEjemplo((v) => !v)}
            className={`rounded-2xl border-2 px-6 py-5 flex flex-col items-center justify-center gap-1.5 text-center transition-colors ${verEjemplo ? 'border-blue-600 bg-blue-50 text-blue-800' : 'border-gray-300 bg-white text-gray-800 hover:border-blue-400 hover:bg-blue-50'}`}>
            <span className="inline-flex items-center gap-2 text-xl md:text-2xl font-bold">{verEjemplo ? <EyeOff size={26} /> : <Eye size={26} />}{verEjemplo ? 'Ocultar ejemplo' : 'Ver ejemplo'}</span>
            <span className="text-sm text-gray-500">Mirá cómo queda en otra obra: {ejemploNombre}</span>
          </button>
          <a href={contratarHref} target="_blank" rel="noopener noreferrer"
            className="rounded-2xl px-6 py-5 flex flex-col items-center justify-center gap-1.5 text-center text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 shadow-md">
            <span className="inline-flex items-center gap-2 text-xl md:text-2xl font-bold"><MessageCircle size={26} />{contratarTexto}</span>
            <span className="text-base font-semibold">{precio}</span>
            {detallePrecio && <span className="text-xs text-white/85">{detallePrecio}</span>}
          </a>
        </div>
      </div>

      {verEjemplo && (
        <div>
          <div className="mb-2 rounded-xl bg-amber-50 border border-amber-200 px-4 py-2 text-sm text-amber-900">
            <b>Ejemplo de otra obra</b> ({ejemploNombre}). Así se va a ver el de tu proyecto cuando lo contrates.
          </div>
          <VisorWeb url={ejemploUrl} titulo={`Ejemplo · ${ejemploNombre}`} tipo={tipo} />
        </div>
      )}

      {beneficios.length > 0 && (
        <ul className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2 text-sm text-gray-700">
          {beneficios.map((t) => (
            <li key={t} className="flex items-start gap-2 bg-white border border-gray-200 rounded-xl px-3 py-2"><Check size={16} className="text-emerald-600 mt-0.5 shrink-0" />{t}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
